module.exports = __webpack_public_path__ + "img/z_b.4b584642.png";